import {
    ATTACHMENT_ITEM_DELETE_ERROR_RESPONSE,
    ATTACHMENT_ITEM_DELETE_REQUEST,
    ATTACHMENT_ITEM_DELETE_RESPONSE,
    ATTACHMENT_ITEM_ERROR_RESPONSE,
    ATTACHMENT_ITEM_REQUEST,
    ATTACHMENT_ITEM_RESPONSE,
    ATTACHMENT_ITEM_SAVE_REQUEST,
    ATTACHMENT_ITEM_SAVE_RESPONSE,
    ATTACHMENT_LIST_CACHED_RESPONSE,
    ATTACHMENT_LIST_ERROR_RESPONSE,
    ATTACHMENT_LIST_REQUEST,
    ATTACHMENT_LIST_RESPONSE,
    ATTACHMENT_UPDATE_ADD_MODEL,
    ATTACHMENT_UPDATE_DELETE_MODEL,
    ATTACHMENT_UPDATE_REMOVE_MODEL
} from "./action-types"
import {
    itemDeleteErrorResponse,
    itemDeleteRequest,
    itemDeleteResponse,
    itemErrorResponse,
    itemRequest,
    itemResponse,
    itemSaveRequest
} from "./default-actions/entity-actions"
import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"

// Entity Request/Response Actions
export const attachmentItemRequest = itemRequest(ATTACHMENT_ITEM_REQUEST)
export const attachmentItemResponse = itemResponse(ATTACHMENT_ITEM_RESPONSE)
export const attachmentItemErrorResponse = itemErrorResponse(
    ATTACHMENT_ITEM_ERROR_RESPONSE
)
export const attachmentItemSaveRequest = itemSaveRequest(
    ATTACHMENT_ITEM_SAVE_REQUEST
)
export const attachmentItemSaveResponse = itemResponse(
    ATTACHMENT_ITEM_SAVE_RESPONSE
)
export const attachmentItemDeleteRequest = itemDeleteRequest(
    ATTACHMENT_ITEM_DELETE_REQUEST
)
export const attachmentItemDeleteResponse = itemDeleteResponse(
    ATTACHMENT_ITEM_DELETE_RESPONSE
)
export const attachmentItemDeleteErrorResponse = itemDeleteErrorResponse(
    ATTACHMENT_ITEM_DELETE_ERROR_RESPONSE
)

// Attachment List Actions
export const attachmentListRequest = listRequest(ATTACHMENT_LIST_REQUEST)
export const attachmentListResponse = listResponse(ATTACHMENT_LIST_RESPONSE)
export const attachmentListCachedResponse = listCachedResponse(
    ATTACHMENT_LIST_CACHED_RESPONSE
)
export const attachmentListErrorResponse = listErrorResponse(
    ATTACHMENT_LIST_ERROR_RESPONSE
)

// Update
export const updateDeleteAttachmentsAction = attachment => ({
    type: ATTACHMENT_UPDATE_DELETE_MODEL,
    attachment
})
export const updateRemoveAttachmentsAction = attachment => ({
    type: ATTACHMENT_UPDATE_REMOVE_MODEL,
    attachment
})
export const updateAddAttachmentsAction = attachment => ({
    type: ATTACHMENT_UPDATE_ADD_MODEL,
    attachment
})
